require('./baseState.js');

PegasusTemplate.InfoGatheringState = PegasusTemplate.BaseState.extend({
  gotoIdle: Em.K,
  headerCopy: {},
  next: '',

  setup: function(){
    var headerData = PegasusTemplate.lookupController('header').get('content');

    this.set( 'next', PegasusTemplate.get('externalProxy.mostRecentPath') );
    this.set( 'headerCopy', $.extend({}, headerData) );
  },

  exitModal: function(){
    PegasusTemplate.lookupController('header').set('content', this.get('headerCopy'));

    PegasusTemplate.stateMachine.closeModal();
    PegasusTemplate.set('status', 'editing');
    PegasusTemplate.stateMachine.transitionTo('idling');
  },

  saveExitModal: function(){
    var path = this.get('next');
    
    PegasusTemplate.stateMachine.closeModal();

    if (path === 'confirm') {
      PegasusTemplate.stateMachine.transitionTo('validating.confirming');
    } else if (path === 'testEmail') {
      PegasusTemplate.get('externalProxy').send('sendTestEmailFromValidationModal');
    } else {
      PegasusTemplate.set('status', 'editing');
      PegasusTemplate.stateMachine.transitionTo('idling');
    }
  }
});
